/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceInvoiceViewRenderRequest
 */
export interface InvoiceInvoiceViewRenderRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceInvoiceViewRenderRequest
     */
    invoice: string;
}

/**
 * Check if a given object implements the InvoiceInvoiceViewRenderRequest interface.
 */
export function instanceOfInvoiceInvoiceViewRenderRequest(value: object): value is InvoiceInvoiceViewRenderRequest {
    if (!('invoice' in value) || value['invoice'] === undefined) return false;
    return true;
}

export function InvoiceInvoiceViewRenderRequestFromJSON(json: any): InvoiceInvoiceViewRenderRequest {
    return InvoiceInvoiceViewRenderRequestFromJSONTyped(json, false);
}

export function InvoiceInvoiceViewRenderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceInvoiceViewRenderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice': json['invoice'],
    };
}

export function InvoiceInvoiceViewRenderRequestToJSON(json: any): InvoiceInvoiceViewRenderRequest {
    return InvoiceInvoiceViewRenderRequestToJSONTyped(json, false);
}

export function InvoiceInvoiceViewRenderRequestToJSONTyped(value?: InvoiceInvoiceViewRenderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice': value['invoice'],
    };
}

